export default "__VITE_ASSET__3ad236df__"